import snakegame from '../../assets/images/portfolio/snake_game.jpg';
import bos2021 from '../../assets/images/portfolio/bos_webdes.png';
import kitapeduli from '../../assets/images/portfolio/kita_peduli.png';
import lyricsgo from '../../assets/images/portfolio/lyrics_go.jpg';
import ptmentol from '../../assets/images/portfolio/library_management.png';
import pokedex from '../../assets/images/portfolio/pokedex.jpg';

let portfolio = [
    {
        id: "pokedex",
        title: "Pokédex",
        short_description: "Pokédex with React and Tailwind",
        description: "A Pokédex application built using React and Tailwind CSS. It utilizes the PokéAPI to display detailed Pokémon information, including types, stats, evolutions, abilities, and weaknesses. Features include real-time search with autocomplete, dynamic type-based icons, and a Pokédex-style layout — designed for both learning and delivering a polished user experience.",
        cover_image: pokedex,
        stack: ["React", "Tailwind"],
        role: "UI/UX, Front-End",
        completion_year: "2025",
        timeline: "May 2025",
        redirect: "https://md-pokedex.vercel.app/",
    },
    {
        id: "snake-game",
        title: "Snake Game",
        short_description: "Modernized Traditional Snake Game",
        description: "A modern Snake Game built using React, TypeScript, and Tailwind CSS. This project was created for learning and fun, showcasing real-time game logic, dynamic UI rendering, and keyboard event handling — all within a React application.",
        cover_image: snakegame,
        stack: ["React", "TypeScript", "Tailwind"],
        role: "UI/UX, Front-End",
        completion_year: "2025",
        timeline: "May 2025",
        redirect: "https://ignatiusmd.github.io/snake_game/",
    },
    {
        id: "kita-peduli",
        title: "Kita Peduli",
        short_description: "Team Project for Invention 2022 Udayana Web Design Competition",
        description: "A website called KitaPeduli aims to provide information about COVID-19 to users, while also serving as a platform for the public to donate to those affected by the pandemic and in need of assistance.",
        cover_image: kitapeduli,
        stack: ["React", "SCSS", "Figma"],
        role: "UI/UX, Front-End",
        completion_year: "2022",
        timeline: "July 2022 - October 2022",
        redirect: "https://ervin-sungkono.github.io/Kita-Peduli/",
    },
    {
        id: "lyrics-go",
        title: "Lyrics-Go",
        short_description: "University Class Assignment",
        description: "Lyrics-Go was developed as a classroom project using Laravel to explore and practice backend web development. The site serves as a platform to browse music lyrics (using placeholder content) and features both a user-facing interface for viewing lyrics and an admin panel for managing content. Users interested in exploring the admin functionalities can log in using the credentials: admin@admin.com with the password AdMin1013.",
        cover_image: lyricsgo,
        stack: ["Laravel", "CSS"],
        role: "Front-End, Back-End, UI/UX",
        completion_year: "2022",
        timeline: "November 2022 - January 2023",
        redirect: "",
    },
    {
        id: "lnt-be-project",
        title: "Library Book Management System",
        short_description: "University Club Final Project",
        description: "PT. Mentol is a web-based library management system developed as a final project for a university club training session. Built using Laravel, this platform allows users to view a collection of books available in the library with information such as page count and publication year. In addition to browsing, users can also contribute to the system by adding new books to the collection, making it a simple yet functional tool for managing library resources digitally.",
        cover_image: ptmentol,
        stack: ["Laravel", "CSS"],
        role: "Back-End, UI/UX",
        completion_year: "2021",
        timeline: "November 2020 - July 2021",
        redirect: "",
    },
    {
        id: "bos-2021",
        title: "BNCC Opening Season",
        short_description: "BNCC Opening Season 2021 Web Design",
        description: "A web design concept for BNCC Opening Season 2021 created in Figma. The layout showcases key event information through structured sections and a vibrant, modern aesthetic.",
        cover_image: bos2021,
        stack: ["Figma"],
        role: "UI/UX",
        completion_year: "2021",
        timeline: "January 2021 - July 2021",
        redirect: "https://www.figma.com/design/PHnbWZ6ERb5j9rMrPUuwky/Web-Design-Portfolio?node-id=0-1",
    },
]

export default portfolio